import { truncateString } from '@capsicum/common';
import { CopyToClipboard, Text } from '@capsicum/common-web';
import { css } from 'styled-components';

const MAX_VALUE_LENGTH = 20;

const wrapperStyle = css`
	gap: ${({ theme }) => theme.spacings.xxxsmall};
`;

export const TextField = ({ isCopyable, value }: { isCopyable?: boolean; value: string }) => {
	if (isCopyable) {
		return <CopyToClipboard label={value} testID={value} value={value} wrapperStyle={wrapperStyle} />;
	}

	return <Text variant="text1">{value.length > MAX_VALUE_LENGTH ? truncateString(value, 8, 8) : value}</Text>;
};
